<ng-container [formGroup]="formGroup">
  <base-form-input
    label="Mode de règlement"
    type="autocomplete"
    [controlName]="paymentMethodControlName"
    [items$]="paymentMethods$"
    displayProperty="label"
    (autocompleteChange)="onPaymentMethodSearch($event)"
    [disabled]="disabled"
  ></base-form-input>

  <div *ngIf="showBankDetails" class="flex flex-row w-full gap-4">
    <base-form-input
      class="w-1/2"
      label="BIC"
      type="text"
      [controlName]="bicControlName"
      [disabled]="disabled"
    ></base-form-input>

    <base-form-input
      class="w-1/2"
      label="IBAN"
      type="text"
      [controlName]="ibanControlName"
      [disabled]="disabled"
    ></base-form-input>
  </div>
</ng-container>
